module.exports = {
	catagory: "bio science",
	defaultImage: "https://cdn.pixabay.com/photo/2013/07/18/10/55/dna-163466_960_720.jpg",
	questions: [
		{
			questionText: `What makes green tea green?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"Chlorophyll",
				],
				incorrect: [
					"Caffeine",
					"Anthocyanins",
					"L-theanine",
				],
			},
			response: `Chlorophylls are green pigments found in the chloroplasts of plants that absorb light energy used in photosynthesis.
				Anthocyanins create a purple colored tea leaf!`,
			tags: ['green tea', 'chemistry', 'visual'],
			citations: ``,
			image: ``
		},
		{
			questionText: `What makes tea sweet?`,
			questionDifficulty: 2,
			answerOptions: {
				correct: [
					"Amino Acids",
				],
				incorrect: [
					"Tannins",
					"GABA",
					"Chlorophyll",
				],
			},
			response: `Not all Amino Acids are sweet (a few are bitter), but L-theanine and D amino acids found in tea are sweet!`,
			tags: [''],
			citations: ``,
			image: ``
		},
		{
			questionText: `What is the Latin name for the tea plant?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"Thea sinensis & Camellia sinensis",
				],
				incorrect: [
					"Thea sinensis",
					"Camellia sinensis",
					"Theanine serene",
					"Theanine sinensis",
				],
			},
			response: `The first edition of Linnaeus's "Species Plantarum" (1753) called the tea plant Thea sinensis.
			In 1818 the genus Thea was cited as a synonym for and combined into the genus Camellia.`,
			tags: [''],
			citations: `https://www.bgbm.org/iapt/nomenclature/code/tokyo-e/Art_13.htm`,
			image: ``
		},
		{
			questionText: `In what Family is the tea plant?`,
			questionDifficulty: 3,
			answerOptions: {
				correct: [
					"Camelliaceae & Theaceae",
				],
				incorrect: [
					"Camelliaceae",
					"Theaceae",
					"Tealeology",
					"Camelogeae",
				],
			},
			response: ``,
			tags: [''],
			citations: ``,
			image: ``
		},
		{
			questionText: `Which are precursors to Caffeine`,
			questionDifficulty: 5,
			answerOptions: {
				correct: [
					"Theobromine & Theophylline",
				],
				incorrect: [
					"Theobromine",
					"Theophylline",
					"Theolafeine",
					"Theocine",
				],
			},
			response: ``,
			tags: [''],
			citations: ``,
			image: ``
		},
		{
			questionText: `Does the plant that makes tea for drinking also make the topical medication known as "tea tree oil"?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"No",
				],
				incorrect: [
					"Yes",
					"Sort of",
					"Nobody knows",
				],
			},
			response: `Tea tree oil comes from Melaleuca alternifolia, a plant native to southeast Queensland and the northeast coast of New South Wales, Australia.`,
			tags: [''],
			image: ``
		},
		{
			questionText: `What is the present day name of the region that is the most likely origin of the tea plant?`,
			questionDifficulty: 3,
			answerOptions: {
				correct: [
					"Yunnan, China",
				],
				incorrect: [
					"Darjeeling, India",
					"Kyoto, Japan",
					"Assam, India",
				],
			},
			response: `There is no doubt that the tea plant first evolved in China, probably in the region now known as Yunnan.`,
			tags: [''],
			image: ``
		},
		{
			questionText: `Is Indian tea the same as Chinese tea?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"Sort of",
				],
				incorrect: [
					"No",
					"Yes",
					"Nobody knows",
				],
			},
			response: `Like humans from Africa, all tea comes from a single common tea ansestor. However, there is debate about the origin of domestication of tea. Some Indian Assam tea has hybridized with Camellia pubicosta, and is decended from related to Western Yunnan tea. Southern Yunnan tea have been hybridized with Camellia taliensis and is quite distinct from Indian tea. India also grows a lot of tea from seeds brought from eastern China in modern times by the British.`,
			tags: [''],
			citations: `https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4878758/`,
			image: ``
		},
		{
			questionText: `About how long ago did Indian and Chinese tea types diverge?`,
			questionDifficulty: 5,
			answerOptions: {
				correct: [
					"3,000 years",
				],
				incorrect: [
					"300 years",
					"22,000 years",
					"220,000 years",
				],
			},
			response: `Results from demographic modeling suggested that the Chinese Large Leaf type tea and Indian Assam type tea lineages diverged 2770 year ago, corresponding well with the early record of tea usage in Yunnan, China.`,
			tags: [''],
			citations: `https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5788969/`,
			image: ``
		},
		{
			questionText: `Roughly how long ago did large leaf and small leaf tea diverge?`,
			questionDifficulty: 5,
			answerOptions: {
				correct: [
					"22,000 years",
				],
				incorrect: [
					"300 years",
					"3,000 years",
					"220,000 years",
				],
			},
			response: `Results from demographic modeling suggested that small leaf tea and large leaf tea first diverged 22,000 year ago during the last glacial maximum.`,
			tags: [''],
			citations: `https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5788969/`,
			image: ``
		},
		{
			questionText: `What was the cause of divergence between small leaf and large leaf tea varieties?`,
			questionDifficulty: 4,
			answerOptions: {
				correct: [
					"The last glacial maximum",
				],
				incorrect: [
					"Human cultivation",
					"The rising Himalayan mountain range",
					"War between India and China",
				],
			},
			response: `Genetic evidence suggests that large leaf and small leaf tea diverged 22,000 years ago, roughly corresponding to the last glacial maximum.`,
			tags: [''],
			citations: `https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5788969/`,
			image: ``
		},
		{
			questionText: `Is Chlorophyll soluble in water?`,
			questionDifficulty: 3,
			answerOptions: {
				correct: [
					"No",
				],
				incorrect: [
					"Yes",
					"Sort of",
					"Nobody knows",
				],
			},
			response: `The long hydrocarbon (phytol) tail attached to the porphyrin ring makes chlorophyll fat-soluble and insoluble in water.`,
			tags: [''],
			citations: `https://lpi.oregonstate.edu/mic/dietary-factors/phytochemicals/chlorophyll-chlorophyllin`,
			image: ``
		},
	]
};